import axios from "axios";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import { select } from "@progress/kendo-react-upload";

export default async function SingleCheckExcelExportWrapper(
  pmid,
  accessToken,
  setIsLoadingFunction
) {
  setIsLoadingFunction(true);
  try {
    const response = await axios.get(`api/Check/GetSingleCheckExcelExport`, {
      params: { pmid: pmid },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    let dataSource = response.data;

    let workbook = XLSX.utils.book_new();

    let payerLocation =
      dataSource.payerCity +
      ", " +
      dataSource.payerState +
      " " +
      dataSource.payerZip;
    let parentCompanyLocation =
      dataSource.parentCompanyCity +
      ", " +
      dataSource.parentCompanyState +
      " " +
      dataSource.parentCompanyZip;

    let paymentSections = {};

    let maximumNumberOfFees = 0;
    let maximumNumberOfSVC = 0;

    for (let count = 0; count < dataSource.paymentDataSection.length; count++) {
      let paymentSectionItem = dataSource.paymentDataSection[count];
      let feesOfPyid = dataSource.paymentFeeCodeSection.filter(
        (x) => x.pyid === paymentSectionItem.pyid
      );

      let paySVC = dataSource.paymentSvcSection.filter(
        (x) => x.pyid === paymentSectionItem.pyid
      );
      if (maximumNumberOfSVC <paySVC.length){
        maximumNumberOfSVC = paySVC.length;
      }

      if (maximumNumberOfFees < feesOfPyid.length) {
        maximumNumberOfFees = feesOfPyid.length;
      }

      //NOTE: each property in paymentSections represents data for a separate NCPDP
      if (paymentSections[paymentSectionItem.ncpdp] == null) {
        paymentSections[paymentSectionItem.ncpdp] = {
          ncpdp: paymentSectionItem.ncpdp,
          storeName: paymentSectionItem.storeName,
          //NOTE: This is an array of objects, each object represents for a given payment
          paymentData: [],
        };
      }

      let pyidData = {
        pyid: paymentSectionItem.pyid,
        fees: feesOfPyid,
        paymentSVC :paySVC,
        rowData: [
          paymentSectionItem.rxNumber,
          DateFormat(paymentSectionItem.serviceDate),
          paymentSectionItem.type,
          currencyFormat(paymentSectionItem.billed),
          currencyFormat(paymentSectionItem.copay),
          paymentSectionItem.concatenatedGroupCodeFeeSection,
          paymentSectionItem.concatenatedReasonCodeFeeSection,
          currencyFormat(paymentSectionItem.adjusted),
          currencyFormat(paymentSectionItem.paid),
          paymentSectionItem.claimNumber,
          paymentSectionItem.patientLastName !== '' && paymentSectionItem.patientFirstName !== '' ? paymentSectionItem.patientLastName + ", " + paymentSectionItem.patientFirstName : paymentSectionItem.patientLastName !== '' ? paymentSectionItem.patientLastName : paymentSectionItem.patientFirstName,
          paymentSectionItem.policyNumber
        ]
      };

      paymentSections[paymentSectionItem.ncpdp].paymentData.push(pyidData);
    }

    let checkAdjustmentSection = [];
    for (
      let count = 0;
      count < dataSource.checkAdjustmentSection.length;
      count++
    ) {
      let checkAdjustmentItem = dataSource.checkAdjustmentSection[count];
      checkAdjustmentSection.push([
        checkAdjustmentItem.memberName,
        checkAdjustmentItem.adjustmentCode,
        currencyFormat(checkAdjustmentItem.amount),
      ]);
    }

    let checkSummarySection = [];
    for (
      let count = 0;
      count < dataSource.checkSummarySection.length;
      count++
    ) {
      let checkSummarySectionItem = dataSource.checkSummarySection[count];
      checkSummarySection.push([
        checkSummarySectionItem.memberName,
        currencyFormat(checkSummarySectionItem.paid),
        currencyFormat(checkSummarySectionItem.adjusted),
        currencyFormat(checkSummarySectionItem.total),
      ]);
    }

    let totalPaid = dataSource.checkSummarySection.reduce(
      (acc, item) => acc + item.paid,
      0
    );
    let totalAdjusted = dataSource.checkSummarySection.reduce(
      (acc, item) => acc + item.adjusted,
      0
    );

    let excelArraySource = [
      ["Payer", "Payee", "Payment"],
      [
        dataSource.payerName,
        dataSource.parentCompanyName,
        "Reference:" + dataSource.checkNumber,
      ],
      [
        dataSource.payerAddressLine1,
        dataSource.parentCompanyAddressLine1,
        "Date:" + DateFormat(dataSource.checkDate),
      ],
      [
        payerLocation,
        parentCompanyLocation,
        "Amount:" + currencyFormat(dataSource.checkAmount),
      ],
    ];

    excelArraySource.push([]); //Empty line

    let paymentSectionsKeys = Object.keys(paymentSections);

    paymentSectionsKeys.forEach(key => {
      let individualNcpdpDataSection = paymentSections[key];
      excelArraySource.push([
        individualNcpdpDataSection.ncpdp + " " + individualNcpdpDataSection.storeName
      ]);

      let paymentHeaders = [
        "Rx Num",
        "Disp Dt",
        "Ty",
        "Billed",
        "Copay",
        "GC",
        "RC",
        "Adjust",
        "Paid",
        "Claim Number",
        "Patient Name",
        "Policy Number"
      ];

        for (let count = 0; count < maximumNumberOfSVC; count++)
        {
        paymentHeaders.push("Service Payment ID");
        paymentHeaders.push("Service Billed Amount");
        paymentHeaders.push("Service Payment Amount");
        paymentHeaders.push("Service Payment Qty");
        }

      for (let count = 0; count < maximumNumberOfFees; count++) {
        paymentHeaders.push("Adjust Group");
        paymentHeaders.push("Adjust Reason");
        paymentHeaders.push("Adjust Amount");
        paymentHeaders.push("Adjust Quantity");
      }

      excelArraySource.push(paymentHeaders);

      for (let count = 0; count < individualNcpdpDataSection.paymentData.length; count++) {
        //NOTE TODO: This previously assumed each value here is a datum,
        //but now I'm going to set one of them as a "list of fees", so we'd need to do a more complex construction
        let selectedRowData = individualNcpdpDataSection.paymentData[count];
        let initialRow = selectedRowData.rowData;
 for (let count = 0; count < maximumNumberOfSVC; count++)
        {
          if(selectedRowData.paymentSVC.length > count){
            let svc = selectedRowData.paymentSVC[count];
            if(svc){
            initialRow.push(svc.svcId);
            initialRow.push(svc.billedAmount);
            initialRow.push(svc.paymentAmount);
            initialRow.push(svc.paymentQuantity);
          }
          }else{
            initialRow.push("");
            initialRow.push("");
            initialRow.push("");
            initialRow.push("");
          }
        }
        // selectedRowData.paymentSVC.forEach(svc =>{
        //   if(svc){
        //     initialRow.push(svc.svcId);
        //     initialRow.push(svc.billedAmount);
        //     initialRow.push(svc.paymentAmount);
        //     initialRow.push(svc.paymentQuantity);
        //   }
        // });

        selectedRowData.fees.forEach(fee => {
          if (fee) {
            initialRow.push(fee.group);
            initialRow.push(fee.reason);
            initialRow.push(currencyFormat(fee.amount));
            initialRow.push(fee.quantity);
          }
        });

        excelArraySource.push(initialRow);
      }
      excelArraySource.push([]); //Empty line
    });

    excelArraySource.push([]); //Empty line
    excelArraySource.push(["Check Adjustments"]);
    excelArraySource.push(["Facility", "Reason", "Amount"]);

    for (let count = 0; count < checkAdjustmentSection.length; count++) {
      excelArraySource.push(checkAdjustmentSection[count]);
    }

    excelArraySource.push([]); //Empty line
    excelArraySource.push(["Check Summary"]);
    excelArraySource.push(["Facility", "Paid", "Adjusted", "Total"]);

    for (let count = 0; count < checkSummarySection.length; count++) {
      excelArraySource.push(checkSummarySection[count]);
    }

    excelArraySource.push([]); //Empty line
    excelArraySource.push(["Total Paid:", currencyFormat(totalPaid)]);
    excelArraySource.push(["Total Adjusted:", currencyFormat(totalAdjusted)]);
    excelArraySource.push([
      "Total:",
      currencyFormat(totalPaid + totalAdjusted),
    ]);

    let worksheet = XLSX.utils.aoa_to_sheet(excelArraySource);
    
    // Apply currency formatting to cells
    applyCurrencyFormatting(worksheet, excelArraySource);
    
    // Apply date formatting to cells
    ApplyDateFormatting(worksheet, excelArraySource);
    
    XLSX.utils.book_append_sheet(workbook, worksheet, "RemittanceLookUp");

    // Generate filename with datetime
    const now = new Date();
    const dateTimeString = `${now.getFullYear()}-${
      now.getMonth() + 1
    }-${now.getDate()}_${now.getHours()}${now.getMinutes()}`;
    const fileName = `REMITANCELOOKUP_${dateTimeString}.xlsx`;

    XLSX.writeFileXLSX(workbook, fileName, { type: "string" });
  } catch (e) {
    console.log(e);
  }
  setIsLoadingFunction(false);
}

function DateFormat(date) {
  return format(new Date(date), "MM/dd/yyy");
}

function currencyFormat(num) {
  return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

function applyCurrencyFormatting(worksheet, excelArraySource) {
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  const currencyFormat = '"$"#,##0.00';
  
  // Loop through each cell in the worksheet
  for (let row = range.s.r; row <= range.e.r; row++) {
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = worksheet[cellAddress];
      
      if (cell && cell.v !== undefined) {
        const cellValue = cell.v.toString();
        
        // Check if the cell contains currency values
        if (cellValue.startsWith('$') || 
            cellValue.includes('Amount:$') ||
            cellValue.includes('Total Paid:') ||
            cellValue.includes('Total Adjusted:') ||
            cellValue.includes('Total:')) {
          
          let numericValue = null;
          
          // Extract numeric value from different formats
          if (cellValue.includes(':$')) {
            // Handle "Amount:$1,234.56" format
            const match = cellValue.match(/:\$?([\d,]+\.?\d*)/);
            if (match) {
              numericValue = parseFloat(match[1].replace(/,/g, ''));
            }
          } else if (cellValue.includes(':')) {
            // Handle "Total Paid: $1,234.56" format
            const match = cellValue.match(/:\s*\$?([\d,]+\.?\d*)/);
            if (match) {
              numericValue = parseFloat(match[1].replace(/,/g, ''));
            }
          } else if (cellValue.startsWith('$')) {
            // Handle "$1,234.56" format
            numericValue = parseFloat(cellValue.replace(/[$,]/g, ''));
          }
          
          // Apply currency formatting if we found a numeric value
          if (numericValue !== null && !isNaN(numericValue)) {
            cell.v = numericValue;
            cell.t = 'n'; // Set cell type to number
            
            // Initialize style object if it doesn't exist
            if (!cell.s) cell.s = {};
            cell.z = currencyFormat;
            
            // Make totals bold
            if (cellValue.includes('Total')) {
              cell.s.font = { bold: true };
            }
          }
        }
        
        // Format currency columns in payment data sections
        const rowData = excelArraySource[row];
        if (rowData && Array.isArray(rowData)) {
          // Check if this is a payment data row (contains currency values in specific columns)
          if (col === 3 || col === 4 || col === 7 || col === 8) { // Billed, Copay, Adjust, Paid columns
            if (typeof cell.v === 'string' && cell.v.startsWith('$')) {
              const numericValue = parseFloat(cell.v.replace(/[$,]/g, ''));
              if (!isNaN(numericValue)) {
                cell.v = numericValue;
                cell.t = 'n';
                if (!cell.s) cell.s = {};
                cell.s.numFmt = currencyFormat;
              }
            }
          }
          
          // Format fee amounts (adjustment amounts in fee columns)
          if (col >= 11 && (col - 11) % 4 === 2) { // Every 4th column starting from column 11 (Adjust Amount columns)
            if (typeof cell.v === 'string' && cell.v.startsWith('$')) {
              const numericValue = parseFloat(cell.v.replace(/[$,]/g, ''));
              if (!isNaN(numericValue)) {
                cell.v = numericValue;
                cell.t = 'n';
                if (!cell.s) cell.s = {};
                cell.s.numFmt = currencyFormat;
              }
            }
          }
        }
      }
    }
  }
  
  // Set column widths for better readability
  worksheet['!cols'] = [
    { wch: 12 }, // Rx Num
    { wch: 10 }, // Disp Dt
    { wch: 5 },  // Ty
    { wch: 12 }, // Billed
    { wch: 10 }, // Copay
    { wch: 8 },  // GC
    { wch: 8 },  // RC
    { wch: 12 }, // Adjust
    { wch: 12 }, // Paid
    { wch: 15 }, // Claim Number
    { wch: 20 }  // Patient Name
  ];
}

function ApplyDateFormatting(worksheet, excelArraySource) {
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  const dateFormat = 'MM/dd/yyyy';
  
  // Loop through each cell in the worksheet
  for (let row = range.s.r; row <= range.e.r; row++) {
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = worksheet[cellAddress];
      
      if (cell && cell.v !== undefined) {
        const cellValue = cell.v.toString();
        
        // Check if the cell contains date values
        if (cellValue.includes('Date:') || 
            (typeof cellValue === 'string' && cellValue.match(/^\d{2}\/\d{2}\/\d{4}$/))) {
          
          let dateValue = null;
          
          if (cellValue.includes('Date:')) {
            // Handle "Date:01/15/2023" format
            const match = cellValue.match(/Date:(\d{2}\/\d{2}\/\d{4})/);
            if (match) {
              dateValue = new Date(match[1]);
            }
          } else if (cellValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            // Handle direct date format "01/15/2023"
            dateValue = new Date(cellValue);
          }
          
          // Apply date formatting if we found a valid date
          if (dateValue && !isNaN(dateValue.getTime())) {
            // Convert to Excel date serial number
            //const excelDate = (dateValue.getTime() - new Date(1900, 0, 1).getTime()) / (24 * 60 * 60 * 1000) + 1;
            
            cell.v = dateValue;
            cell.t = 'd'; // Set cell type to date only
            
            // Initialize style object if it doesn't exist
            if (!cell.s) cell.s = {};
            cell.z = dateFormat;
          }
        }
        
        // Format date columns in payment data sections
        const rowData = excelArraySource[row];
        if (rowData && Array.isArray(rowData)) {
          // Check if this is the "Disp Dt" column (column 1 in payment data sections)
          if (col === 1 && typeof cell.v === 'string' && cell.v.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            const dateValue = new Date(cell.v);
            if (!isNaN(dateValue.getTime())) {
              // Convert to Excel date serial number
              //const excelDate = (dateValue.getTime() - new Date(1900, 0, 1).getTime()) / (24 * 60 * 60 * 1000) + 1;
              
              cell.v = dateValue;
              cell.t = 'd';
              if (!cell.s) cell.s = {};
              cell.z = dateFormat;
            }
          }
          
          // Also check for any date-like strings in other columns
          if (typeof cell.v === 'string' && cell.v.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            const dateValue = new Date(cell.v);
            if (!isNaN(dateValue.getTime())) {
              // Convert to Excel date serial number  
              //const excelDate = (dateValue.getTime() - new Date(1900, 0, 1).getTime()) / (24 * 60 * 60 * 1000) + 1;
              
              cell.v = dateValue;
              cell.t = 'd';
              if (!cell.s) cell.s = {};
              cell.z = dateFormat;
            }
          }
        }
      }
    }
  }
}
